<script lang="ts" setup>
import { useI18n } from "vue-i18n"
import { computed } from "vue"
import { useIrveStore } from "@modules/irve/stores/irve.store"

const irveStore = useIrveStore()

const { t } = useI18n({
    messages: {
        fr: {
            title: "Impact de l'installation",
            energie_elec: {
                title: "Consommation annuelle des bornes",
                tooltip:
                    "Consommation annuelle estimée des bornes installées (en kWh)",
            },
            cout_depassement: {
                title: "Pénalité de dépassement de puissance",
                tooltip:
                    "Pénalité de dépassement de puissance souscrite (CMPDS) générée par les bornes, due à des appels de puissance supérieurs à la puissance souscrite actuelle.",
            },
        },
    },
})

const getConfigIndicators = computed(() => {
    const cout =
        irveStore.getCurrentAnalysis?.outputs?.periode?.cout_elec_turpeCMDPS
            ?.sum

    const conso =
        irveStore.getCurrentAnalysis?.outputs?.periode?.energie_elec_borne?.sum

    return [
        {
            value:
                conso !== undefined
                    ? Intl.NumberFormat("fr").format(conso)
                    : "-",
            name: t("energie_elec.title"),
            unit: "kWh",
            icon: "pi pi-bolt",
            color: "#EEC137",
            tooltip: t("energie_elec.tooltip"),
            loading: irveStore.isFetchingAnalysis,
        },
        {
            value:
                cout !== undefined
                    ? Intl.NumberFormat("fr", {
                          style: "currency",
                          currency: "EUR",
                      }).format(cout)
                    : "-",
            name: t("cout_depassement.title"),
            icon: "pi pi-bolt",
            unit: "HTVA / an",
            color: "#41C5B7",
            tooltip: t("cout_depassement.tooltip"),
            textColor: cout !== undefined && cout > 0 ? "var(--p-red-500)" : "",
            loading: irveStore.isFetchingAnalysis,
        },
    ]
})
</script>

<template>
    <div class="irve-view-indicators flex flex-col gap-5">
        <h1 class="font-bold text-primary-700 text-lg">{{ t("title") }}</h1>
        <div
            class="grid grid-cols-2 gap-6 overflow-x-auto overflow-y-hidden [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden [&_.indicator-item]:min-w-[26rem] [&_.indicator-item__title]:whitespace-nowrap"
        >
            <BaseIndicatorItem
                v-for="(indicator, key) in getConfigIndicators"
                :key="key"
                :icon="indicator.icon"
                :icon-color="indicator.color"
                :name="indicator.name"
                :value="indicator.value"
                :unit="indicator.unit"
                :tooltip="indicator.tooltip"
                :text-color="indicator.textColor"
                :loading="indicator.loading"
            />
        </div>
    </div>
</template>
